export enum ModalSize {
  L = "l",
  M = "m",
  S = "s",
}
